export default function timeSinceLastUpdate(lastTimeUpdated) {
    if (!lastTimeUpdated || isNaN(lastTimeUpdated)) {
        return 'Time not available'
    }

    const now = Date.now()
    const diffInMilliseconds = now - lastTimeUpdated
    const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60))
    const diffInHours = Math.ceil(diffInMilliseconds / (1000 * 60 * 60))

    if (diffInMinutes <= 3) {
        return 'just now'
    }

    if (diffInMinutes > 3 && diffInMinutes < 60) {
        return `less than 1 hour ago`
    }

    if (diffInHours <= 12) {
        return `less than ${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`
    }

    if (diffInHours <= 24) {
        return 'more than 12 hours ago'
    }

    if (diffInHours <= 48) {
        return 'more than 24 hours ago'
    }

    if (diffInHours <= 72) {
        return 'more than 48 hours ago'
    }

    return 'more than 72 hours ago'
}
